import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * `bannerAspect` must match the `TopicCard` it stands in for. Browse renders
 * cards at `h-28` while this defaulted to `aspect-[16/9]` — 210px against
 * 112px, so every skeleton was ~98px too tall and the grid collapsed when the
 * real cards arrived.
 */
const TopicCardSkeleton = ({ bannerAspect = "aspect-[16/9]" }: { bannerAspect?: string }) => {
    return (
        <Card className="overflow-hidden rounded-2xl border border-stone-200/60 dark:border-stone-700/60 bg-card h-full flex flex-col">
            <div className={cn("relative w-full bg-muted/50", bannerAspect)}>
                <Skeleton className="absolute top-2 left-2 h-5 w-20 rounded-md" />
            </div>
            <div className="p-3 sm:p-4 flex flex-col flex-1">
                {/* Title */}
                <Skeleton className="h-5 w-full mb-1.5" />
                <Skeleton className="h-5 w-3/4 mb-2" />

                {/* Content-count chip row */}
                <div className="flex items-center gap-1.5 mb-2">
                    <Skeleton className="h-5 w-20 rounded-md" />
                    <Skeleton className="h-5 w-16 rounded-md" />
                </div>

                {/* Stats row */}
                <div className="flex items-center gap-2 mb-2 mt-1">
                    <Skeleton className="h-3 w-8" />
                    <Skeleton className="h-3 w-8" />
                    <Skeleton className="h-3 w-8" />
                </div>

                {/* Creator divider */}
                <div className="flex items-center gap-2 pt-2 border-t border-stone-200/60 dark:border-stone-700/60 mt-auto">
                    <Skeleton className="w-5 h-5 md:w-6 md:h-6 rounded-full" />
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-3 w-12 ml-auto" />
                </div>
            </div>
        </Card>
    );
};

export default TopicCardSkeleton;
